import React from 'react';
import SidebarOverlay from '../../components/sidebarOverlay';
import SidebarContent from './sidebarContent';

const ChatSidebar = React.memo(() => {


    return (
        <>
            <div className="hidden lg:flex xl:inset-y-0 xl:flex xl:w-[320px] bg-chat-bg-color xl:flex-col relative">
                <SidebarContent />
            </div>
            <div className="md:hidden">
                <SidebarOverlay />
            </div>
        </>
    );
});

export default ChatSidebar;